import { LayoutServiceData } from '@sitecore-jss/sitecore-jss-nextjs';
import { GtmConstants, GtmDimensions, GtmEventNames } from 'google-tag-manager';
import {
  getPageNameFromSitecore,
  getBreakpointName,
  getCurrentPageUrl,
  getEnvironmentName,
  getLangCode,
  getAuthenticationStatus,
  removeAnalyticsAuthenticationValue,
  getPageCategoryFromSitecore,
  getPageReferral,
  getScreenOrientation,
  getTimeStamp,
  getVersionNumber,
  pushToDataLayer,
  setReferralPages,
  setPageName,
  setPageCategory,
  getReferralPageName,
  getReferralPageCategory,
  getPageNameFromSessionStorage,
  getPageCategoryFromSessionStorage
} from './utils/helpers';

export const pushPageLoadAnalyticsData = async (sitecoreLayoutService?: LayoutServiceData) => {
  const pageName = sitecoreLayoutService?.sitecore?.route
    ? getPageNameFromSitecore(sitecoreLayoutService.sitecore.route)
    : getPageNameFromSessionStorage();
  const pageCategory = sitecoreLayoutService?.sitecore?.route
    ? getPageCategoryFromSitecore(sitecoreLayoutService.sitecore.route)
    : getPageCategoryFromSessionStorage();
  setPageName(pageName);
  setPageCategory(pageCategory);
  removeAnalyticsAuthenticationValue();

  const pageData = {
    [GtmDimensions.event]: GtmEventNames.pageLoad,
    [GtmDimensions.pageName]: pageName,
    [GtmDimensions.pageCategory]: pageCategory,
    [GtmDimensions.pageReferral]: getPageReferral(),
    [GtmDimensions.userId]: GtmConstants.notImplementedValue,
    [GtmDimensions.businessChannel]: GtmConstants.businessChannel,
    [GtmDimensions.businessType]: GtmConstants.businessType,
    [GtmDimensions.environment]: getEnvironmentName(),
    [GtmDimensions.siteVersion]: getVersionNumber(),
    [GtmDimensions.pageLanguage]: getLangCode(),
    [GtmDimensions.pageUrl]: getCurrentPageUrl(),
    [GtmDimensions.screenOrientation]: getScreenOrientation(),
    [GtmDimensions.responsivePagebreakView]: getBreakpointName(),
    [GtmDimensions.referralPageName]: getReferralPageName(),
    [GtmDimensions.referralPageCategory]: getReferralPageCategory(),
    [GtmDimensions.testVariant]: GtmConstants.testVariant,
    [GtmDimensions.timestamp]: getTimeStamp(),
    [GtmDimensions.loggedInStatus]: await getAuthenticationStatus(),
    [GtmDimensions.checkedInStatus]: GtmConstants.notImplementedValue,
    [GtmDimensions.checkInOpen]: GtmConstants.notImplementedValue,
    [GtmDimensions.upcomingBookings]: '',
    [GtmDimensions.pastDisruptedBookings]: '',
    [GtmDimensions.nextBookings]: '',
    [GtmDimensions.otherBookings]: ''
  };
  pushToDataLayer(pageData);
  setReferralPages(pageName, pageCategory);
};
